import React, { useEffect, useRef, useState } from 'react';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/browser';

import { useAppContext } from '../../hooks';

import PlacesSearchField from './PlacesSearchField';

function AddressFormField({ countryCode, onPlaceSelect, onPlaceDismiss }) {
  const { placesService } = useAppContext();
  const { values, errors } = useFormikContext();

  const lastSelectedAddress = useRef('');
  const [query, setQuery] = useState('');

  useEffect(() => {
    if (values.google_places_id) {
      placesService
        .getDetails({
          placeId: values.google_places_id,
          fields: ['formatted_address'],
        })
        .then((place) => {
          lastSelectedAddress.current = place.formatted_address;
          setQuery(place.formatted_address);
        })
        .catch((error) => {
          Sentry.captureException(error);
          console.log(error);
        });
    }
  }, []); // eslint-disable-line

  return (
    <PlacesSearchField
      searchType="address"
      countryCode={countryCode}
      name="google_places_id"
      label={`${i18n.gettext('Restaurant address')} *`}
      error={
        errors.google_places_id ||
        errors.street ||
        errors.city ||
        errors.country
      }
      value={query}
      onChange={setQuery}
      onBlur={() => {
        if (values.google_places_id && query !== lastSelectedAddress.current) {
          onPlaceDismiss();
        }
      }}
      onSelect={async (suggestion) => {
        const place = await placesService.getDetails({
          fields: ['place_id', 'address_components', 'formatted_address'],
          placeId: suggestion.place_id,
        });
        lastSelectedAddress.current = place.formatted_address;
        setQuery(place.formatted_address);
        onPlaceSelect(place);
      }}
    />
  );
}

AddressFormField.propTypes = {
  countryCode: PropTypes.string,
  onPlaceSelect: PropTypes.func.isRequired,
  onPlaceDismiss: PropTypes.func.isRequired,
};

export default AddressFormField;
